import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getSettingList() {
  return request({
    url: '/GetSettingList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 801,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function updateTruthValue(params) {
  return request({
    url: '/UpdateTruthValue',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 802,
      MessageID: btcguid(),
      Data: {
        TorF: params.TorF,
        SettingName: params.SettingName,
        SettingID: params.SettingID
      }
    }
  })
}

export function updateState(params) {
  return request({
    url: '/UpdateState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 802,
      MessageID: btcguid(),
      Data: {
        State: params.State,
        SettingName: params.SettingName,
        SettingID: params.SettingID
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/setting.js